<section class="rewards-section">
  <span #reviews
        class="visually-hidden"></span>
  <div class="width-wrapper">
    <h2 class="rewards-title">Награды</h2>

    <div class="rewards-list">
      <div class="reward-wrapper">
        <div class="reward-mth">
          <img class=""
               src="../../../assets/img/moscow-travel-hub.png"
               alt="Moscow travel hub"
               width="468"
               height="475">
          <p>
            Победитель акселератора "Фабрика туристических продуктов и сервисов" <br>Один из лучших B2B трэвел стартапов 2020
          </p>
        </div>
        <img class="certificateSK"
             src="../../../assets/img/certificateSK.png"
             alt="Certificate SK"
             width="411"
             height="588">
      </div>

      <div class="reward-wrapper Certificates">
        <img class=""
             src="../../../assets/img/certificateStart.png"
             alt="Certificate Start"
             width="710"
             height="497">
        <img class=""
             src="../../../assets/img/certificateMTS.png"
             alt="Certificate MTS"
             width="710"
             height="497">
      </div>
    </div>
  </div>
</section>
